import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AmplifyAuthService } from '../services/auth/amplify-auth.service';

export const noAuthGuard: CanActivateFn = (): boolean => {
    const router = inject(Router);
    const amplifyAuthService = inject(AmplifyAuthService);

    if (amplifyAuthService.authState().isAuthenticated) {
        router.navigate(['/home/mantenedores']);
        return false;
    }
    return true;
};
